<script setup lang="ts">
  import type { PopularSearchLinkStoryblok } from '@/storyblok/component-types-sb'
  import { useMainHeaderStore } from '@/components/main-header/store'

  defineProps<{
    links: PopularSearchLinkStoryblok[]
  }>()

  const mainHeaderStore = useMainHeaderStore()
</script>

<template>
  <div class="space-y-4">
    <span class="text-sm">{{ $t('mainNavigation.search.popularSearches') }}</span>
    <div class="flex flex-col items-start gap-4 md:flex-row md:flex-wrap">
      <NuxtLink
        v-for="link in links"
        :key="link._uid"
        :to="link.link?.href || link.link?.cached_url"
        class="cursor-default rounded-full border border-border px-4 py-1.5 text-sm no-underline transition-colors hover:bg-bt-blue-ui hover:text-white"
        external
        @click="mainHeaderStore.isDesktopSearchOpen = false"
      >
        {{ link.title }}
      </NuxtLink>
    </div>
  </div>
</template>
